import React,{useState} from "react";
import Classes from  "./Certificates.module.css";
import Carousel from "react-elastic-carousel";
import CertificateData from "../../Data/certificateData";

const breakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 550, itemsToShow: 2 },
  { width: 768, itemsToShow: 3 },
  { width: 1200, itemsToShow: 4 },
];


const Certificates = () => {
  
  const [datas, setDatas] = useState(CertificateData)
  return (
    <div id="certificates">
      <div className={Classes.Certificate_heading}>
        <p>Certification</p>
      </div>
     
      <div className={Classes.Certificate_block}>
        <div className={Classes.Certificate_block_child}>
          <Carousel breakPoints={breakPoints}>
            {datas.map((data)=>{
                const{id, drive, IssuedDate,Course_Name,University_logo}=data;
                return (
                  <div className={Classes.c} key={id}>
                    <a href={drive} target="_blank" rel="noreferrer">
                      <div className={Classes.fig}>
                        <img src={University_logo} className={Classes.im} alt="certificates" />
                      </div>
                      <div className={Classes.caption}>
                        <h4>{Course_Name}</h4>
                        <p>{IssuedDate}</p>
                      </div>
                    </a>
                </div>
                )
            })}
           
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Certificates;
